/* Naturealm Learn: How to Use It. Picks a starting point from what the visitor already has every day. */
(function () {
  var root = document.querySelector('[data-hu]');
  if (!root) return;
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var UTM = '?utm_source=learn&utm_medium=tool&utm_campaign=how-to-use';
  var S7 = ['Shop Sacred 7', '/products/sacred-7-medicinal-mushroom-extract'];

  var W = {
    coffee:   { name: 'Coffee', how: 'Stir one level teaspoon into a splash of your coffee until smooth, then pour in the rest. For iced coffee, mix it with a little hot water first.', link: ['How much to add', '/blogs/news/can-you-add-mushroom-powder-to-coffee'], next: ['cocoa', 'oats'] },
    cocoa:    { name: 'Hot cocoa', how: 'Whisk one level teaspoon with your cocoa powder and a splash of hot milk into a paste, then top it up. The easiest coffee-free option.', link: S7, next: ['tea', 'smoothie'] },
    matcha:   { name: 'Matcha or chai', how: 'Whisk one level teaspoon in with your matcha before the water, or stir it into chai. The spices in chai make it the most forgiving start.', link: S7, next: ['smoothie', 'tea'] },
    smoothie: { name: 'Smoothie or shake', how: 'Add one level teaspoon to the blender or shaker bottle with everything else. Banana, cocoa, and peanut butter pair well.', link: ['Get the green smoothie recipe', '/blogs/news/how-to-make-the-green-sacred-7-mushroom-powder-smoothie'], next: ['oats', 'cocoa'] },
    oats:     { name: 'Oatmeal or yogurt', how: 'Stir one level teaspoon into cooked oatmeal, or into yogurt with fruit. Overnight oats on Sunday take care of most of the week.', link: ['Get the overnight oats recipe', '/blogs/news/sacred-7-overnight-oats-recipe'], next: ['smoothie', 'soup'] },
    soup:     { name: 'Soup or broth', how: 'Stir one level teaspoon into a mug of broth or a bowl of soup just before serving. Shiitake and Maitake are two of the seven, so savory food fits.', link: ['Get the golden soup recipe', '/blogs/news/sacred-7-golden-mushroom-soup-recipe'], next: ['tea', 'oats'] },
    tea:      { name: 'Tea', how: 'Stir one level teaspoon into a cup of herbal tea after dinner. A caffeine-free tea fits the end of your day.', link: S7, next: ['cocoa', 'soup'] },
    none:     { name: 'Sacred 7 Capsules', how: 'Three capsules with breakfast give you the same 1,000mg as a level teaspoon. Keep the bottle wherever you eat so it’s in front of you each day.', link: ['Shop Sacred 7 Capsules', '/products/sacred-7-mushroom-extract-capsules'], next: ['coffee', 'cocoa'] }
  };

  var pick = 'coffee';
  var startEl = root.querySelector('[data-hu-start]');
  var nextEl = root.querySelector('[data-hu-next]');

  function li(strong, text, link, key) {
    var el = document.createElement('li');
    var b = document.createElement('strong');
    b.textContent = strong;
    el.appendChild(b);
    el.appendChild(document.createTextNode(' ' + text + ' '));
    if (link) {
      var a = document.createElement('a');
      a.className = 'tt-shop';
      a.href = link[1] + UTM;
      a.textContent = link[0] + ' →';
      a.addEventListener('click', function () { push('how_to_use_click', { way: key }); });
      el.appendChild(a);
    }
    return el;
  }

  function render() {
    var w = W[pick];
    startEl.innerHTML = '';
    nextEl.innerHTML = '';
    startEl.appendChild(li(w.name + '.', w.how, w.link, pick));
    w.next.forEach(function (k) {
      var n = W[k];
      nextEl.appendChild(li(n.name + '.', n.how, null, k));
    });
  }

  $$('[data-hu-w]').forEach(function (b) {
    b.addEventListener('click', function () {
      pick = b.getAttribute('data-hu-w');
      $$('[data-hu-w]').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      render();
      push('how_to_use_pick', { way: pick });
    });
  });

  function push(evt, data) {
    try { window.dataLayer = window.dataLayer || []; data = data || {}; data.event = evt; window.dataLayer.push(data); } catch (e) {}
  }

  // Daily reminder as a calendar file (.ics), same as When to Take It
  var icsBtn = root.querySelector('[data-hu-ics]');
  var timeEl = root.querySelector('[data-hu-time]');
  if (icsBtn) icsBtn.addEventListener('click', function () {
    var t = (timeEl && timeEl.value) || '08:00';
    var hh = t.split(':')[0], mm = t.split(':')[1] || '00';
    var d = new Date(); d.setDate(d.getDate() + 1);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var day = d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate());
    var summary = pick === 'none' ? 'Take 3 Sacred 7 capsules' : 'One teaspoon of Sacred 7 in your ' + W[pick].name.toLowerCase();
    var stamp = new Date().toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    var ics = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Naturealm//How to Use It//EN', 'BEGIN:VEVENT',
      'UID:' + Date.now() + '@naturealm.co', 'DTSTAMP:' + stamp,
      'DTSTART:' + day + 'T' + hh + mm + '00', 'DURATION:PT5M', 'RRULE:FREQ=DAILY',
      'SUMMARY:' + summary.replace(/,/g, '\\,'),
      'DESCRIPTION:Same cup, same time. naturealm.co/pages/learn-how-to-use',
      'BEGIN:VALARM', 'TRIGGER:PT0M', 'ACTION:DISPLAY', 'DESCRIPTION:' + summary.replace(/,/g, '\\,'), 'END:VALARM',
      'END:VEVENT', 'END:VCALENDAR'
    ].join('\r\n');
    var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'naturealm-daily-reminder.ics';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
    icsBtn.textContent = 'Reminder Downloaded';
    setTimeout(function () { icsBtn.textContent = 'Add Daily Reminder'; }, 2500);
    push('how_to_use_reminder', { time: t, way: pick });
  });

  render();
})();
